export const JWT_RESPONSE_HEADER = 'token';
export const CSRF_HEADER = 'X-CSRF-TOKEN';
export const TIME = 'X-TIME';
